<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 19 13">
    <path
      d="M3.5 6.5H15.5M0.5 0.5H18.5M6.5 12.5H12.5"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
